/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
require("./src/styles/global.css");
// You can delete this file if you're not using it
import React from "react";
import ReduxWrapper from "./src/pages/ReduxWrapper";
import { StyledEngineProvider } from "@mui/material/styles";

export const wrapRootElement = ({ element }) => {
  // Wrap with Material-UI's StyledEngineProvider to fix SSR issues
  return (
    <StyledEngineProvider injectFirst>
      <ReduxWrapper element={element} />
    </StyledEngineProvider>
  );
};
